<template>
  <div>
    <cards-container @showDownloadModal="showDownloadModal"></cards-container>
    <transactions-export-modal
      v-if="showTransactionDownloadModalFlag"
      :downloadMode="true"
      :open.sync="showTransactionDownloadModalFlag"
      :extraFilters="downloadDataFilters"
      overlay
      @closeModal="removeHash"
    ></transactions-export-modal>
  </div>
</template>

<script>
import CardsContainer from '@/modules/cards/_components/_shared/CardsContainer'
import { segmentTrack } from '@/analytics/segment'
const TransactionsExportModal = () => import('../../../transactions/_components/_shared/TransactionsExportModal.vue')
export default {
  name: 'UserCards',
  components: { CardsContainer, TransactionsExportModal },
  data () {
    return {
      downloadDataFilters: {},
      showTransactionDownloadModalFlag: false
    }
  },
  computed: {
    userId () {
      return this.$route.params.id || 0
    },
    cardCount () {
      return this.$store.getters['CardsStore/totalItems']
    }
  },
  methods: {
    async fetchCards () {
      let filters = {
        'user.id': this.userId
      }
      await this.$store.dispatch('CardsStore/setCardsFilters', filters)
    },
    showDownloadModal (filters) {
      this.downloadDataFilters = filters
      this.showTransactionDownloadModalFlag = true
    },
    removeHash () {
      if (window.location.hash === '#exportHistory') {
        window.location.hash = ''
      }
    }
  },
  async created () {
    this.$store.dispatch('CardsStore/clearStore')
    await this.fetchCards()
    segmentTrack('User member cards opened', {
      member_card_count: this.cardCount
    })
  }

}
</script>

<style>
</style>
